/**
 * Enterprise sales contact, resolved from the domain the app is served on. The
 * same SPA runs on every brand's domain, so each routes to its own inbox:
 *   integra.blueberrydigital.co.uk -> enterprise@blueberrydigital.co.uk
 *   integra.fruitfulbough.uk       -> enterprise@fruitfulbough.uk
 * Unknown hosts (localhost, Vercel previews) fall back to the estate default.
 *
 * This is only the PUBLIC alias shown and mailto'd — where it actually delivers
 * (a personal or shared inbox) is a mail-provider forwarding rule, never in code,
 * so a real address is never exposed on the page. Add a brand's apex domain here
 * as new white-label domains come online.
 */
export const ENTERPRISE_DOMAINS = ['blueberrydigital.co.uk', 'fruitfulbough.uk'] as const;

const DEFAULT_ENTERPRISE_DOMAIN = 'fruitfulbough.uk';

export function enterpriseSalesEmail(): string {
  const host = typeof window === 'undefined' ? '' : window.location.hostname.toLowerCase();
  const match = ENTERPRISE_DOMAINS.find((d) => host === d || host.endsWith(`.${d}`));
  return `enterprise@${match ?? DEFAULT_ENTERPRISE_DOMAIN}`;
}

export function enterpriseMailto(subject = 'INTEGRA Enterprise enquiry'): string {
  return `mailto:${enterpriseSalesEmail()}?subject=${encodeURIComponent(subject)}`;
}
